import { yupResolver } from '@hookform/resolvers/yup';
import { enqueueSnackbar } from 'notistack';
import React from 'react';
import { Resolver, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { EHolidayType } from '../../../../shared/enums/holiday/EHoliday';
import { ECountry } from '../../../../shared/enums/user/ECountry';
import { EReligion } from '../../../../shared/enums/user/EReligion';
import { handleError } from '../../../../shared/functions/handleError';
import { IHoliday } from '../../../../shared/interfaces/holiday/IHoliday';
import { AdminHolidaysService } from '../service';
import HolidayForm from './HolidayForm';

export const holidaySchema = yup.object().shape({
  holidayType: yup
    .mixed<EHolidayType>()
    .oneOf(Object.values(EHolidayType))
    .required('validation.required'),
  country: yup
    .string()
    .oneOf(Object.values(ECountry), 'validation.invalidOption')
    .required('validation.required'),
  religion: yup
    .string()
    .oneOf(Object.values(EReligion), 'validation.invalidOption')
    .when('holidayType', {
      is: (type: EHolidayType) => type === 'religious',
      then: (schema) => schema.required('validation.required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  name: yup.string().required('validation.required'),
  year: yup.number().required('validation.required'),
  startDate: yup.string().required('validation.required'),
  endDate: yup.string().required('validation.required'),
});

const HolidayCreate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { handleSubmit, control, watch } = useForm<IHoliday>({
    resolver: yupResolver(holidaySchema) as unknown as Resolver<IHoliday>,
  });

  const submitHandler = (formData: IHoliday) => {
    AdminHolidaysService.create(formData)
      .then((response) => {
        if (response) {
          navigate(-1);
          enqueueSnackbar(
            t('toasts.successfullyCreated', { title: formData?.name }),
            {
              variant: 'success',
            },
          );
        }
      })
      .catch((err) => handleError(err));
  };

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <HolidayForm control={control} watch={watch} />
    </form>
  );
};

export default HolidayCreate;
